/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import './login.less';
import { Form } from '@ant-design/compatible';
import { Col, Row } from 'antd';
import '@ant-design/compatible/assets/index.css';
import LoginFactory from './login.factory';

import loginLogo from '../../assets/images/ontraccr-login-logo.png';
import loginSide from '../../assets/images/ontraccr-login-img.jpg';

import analytics from '../../helpers/Analytics';
import RedesignLoginFormContainer from './RedesignLoginFormContainer';
import LoginImageInfoContainer from './LoginImageInfoContainer';

const LoginPage = Form.create({ name: 'normal_login' })(
  class Login extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        loggedIn: false,
        loading: false,
        username: '',
        password: '',
        isReset: false,
        showRegister: false,
      };
      this.onSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
      const {
        location: {
          pathname,
        } = {},
      } = this.props;
      if (pathname.includes('/login')) {
        if (pathname.includes('token=')) {
          const token = pathname.substr(pathname.indexOf('token=') + 6);
          this.handleToken(token);
        } else {
          analytics.track('GetStarted/LoginPage');
        }
      }
    }

    async handleToken(token) {
      const { isError, error } = await LoginFactory.login(null, null, token);
      if (!isError) this.props.history.push('/dashboard');
      else this.setState({ error });
    }

    async handleSubmit({
      username,
      password,
    }) {
      const {
        isReset,
      } = this.state;

      await this.setState({ error: null });
      if (!username) return;
      if (isReset) {
        const { data } = await LoginFactory.forgotPassword(username);
        if (data) {
          this.setState({
            isReset: false,
            error: null,
          });
        }
      } else {
        if (!password) return;
        const { isError, error } = await LoginFactory.login(username, password);
        if (!isError) this.props.history.push('/dashboard');
        else this.setState({ error });
      }
    }

    render() {
      const {
        isReset,
        error,
      } = this.state;
      return (
        <div className="login-page">
          <Row gutter={16} style={{ padding: 24, height: '100%' }}>
            <Col span={12} style={{ height: '100%' }}>
              <RedesignLoginFormContainer
                style={{ top: 0 }}
                isReset={isReset}
                onSubmit={this.onSubmit}
                onResetButtonClicked={() => {
                  analytics.track(`GetStarted/${isReset ? 'LoginPage' : 'ForgotPW'}`);
                  this.setState({
                    isReset: !isReset,
                    error: null,
                  });
                }}
                image={(
                  <img alt="Ontraccr Logo" src={loginLogo} className="login-logo" />
                )}
                error={error}
                isRedesign
              />
            </Col>
            <Col span={12} style={{ height: '100%' }}>
              <div className="login-side-image-container">
                <img alt="Ontraccr Side" src={loginSide} className="login-side-image" />
                <LoginImageInfoContainer />
              </div>
            </Col>
          </Row>
        </div>
      );
    }
  },
);

export default LoginPage;
